import { render, staticRenderFns } from "./StakeAutocomplete.vue?vue&type=template&id=0b50cea2&scoped=true&"
import script from "./StakeAutocomplete.vue?vue&type=script&setup=true&lang=js&"
export * from "./StakeAutocomplete.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./StakeAutocomplete.vue?vue&type=style&index=0&id=0b50cea2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b50cea2",
  null
  
)

export default component.exports